import { FunctionComponent } from 'react';
import { twMerge } from 'tailwind-merge';

import { DropdownMenu, DropdownMenuItem } from '../ui';

export type DependentCardProps = {
  displayName: string;
  emailAddress: string;
  phoneNumber: string;
  pending: boolean;
  menuItems: DropdownMenuItem[];

  className?: string;
};

export const DependentCard: FunctionComponent<DependentCardProps> = ({
  displayName,
  emailAddress,
  phoneNumber,
  pending,
  menuItems,

  className,
}) => {
  return (
    <div
      className={twMerge(
        'relative inline-flex items-start justify-start rounded-lg border border-neutral-200 bg-white pb-4 shadow',
        className,
      )}
    >
      <div className="inline-flex shrink grow basis-0 flex-col items-start justify-start gap-3 pt-4">
        {pending && (
          <div className="inline-flex items-start justify-start gap-2 rounded-br-lg rounded-tr-lg bg-lime-300/30 py-1 pl-4 pr-3">
            <div className="text-sm font-medium leading-tight text-gray-800">Pending</div>
          </div>
        )}
        <div className="flex flex-col items-start justify-start gap-2 self-stretch px-4">
          <div data-testid="dependent-displayName" className="self-stretch text-lg font-bold leading-7 text-gray-800">
            {displayName}
          </div>
          <div
            data-testid="dependent-emailAddress"
            className="self-stretch text-sm font-medium leading-tight text-stone-500"
          >
            {emailAddress}
          </div>
          <div
            data-testid="dependent-phoneNumber"
            className="self-stretch text-sm font-medium leading-tight text-stone-500"
          >
            {phoneNumber}
          </div>
        </div>
      </div>
      {menuItems && (
        <div className="absolute right-3 top-4">
          <DropdownMenu items={menuItems} />
        </div>
      )}
    </div>
  );
};
